import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { BusinessTransactionType } from '../../../../foundation/models/enums/business-transaction-type.enum';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { TitleOnlyModel } from '../../../models/title-only.model';
import { TitleModel } from '../../../models/title.model';
import { TransactionService } from '../../../services/transaction.service';
import { NMVTISMessageModel } from '../../models/nmvtis-message.model';
import { VehicleNoTitleHistoryModel } from '../../models/vehiclenotitlehistory.model';
import { VehicleOwnershipReasonType } from '../../../models/enums/vehicle-ownership-reason-type.enum';

@Component({
    selector: 'vehicle-matched',
    templateUrl: './vehicle-matched.html',
    inputs: ['nmvtisMessageModel'],
    outputs: ['onSaved']
})
export class VehicleMatchedComponent extends BaseComponent implements OnInit {
    public vehicleSelectionForm: UntypedFormGroup;
    public dataLoaded = false;
    public nmvtisMessageModel: NMVTISMessageModel;
    public vehicleNoTitleHistoryList: VehicleNoTitleHistoryModel[];
    public selectedVehicle: VehicleNoTitleHistoryModel;
    public onSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
    private title: TitleModel;
    private businessTransactionNumber: number;
    private businessTransactionTypeId: number;
    private vehicleOwnershipReasonTypeId: number;
    private transaction: any;
    public message: string;

    constructor(private _transactionService: TransactionService,
        private _route: ActivatedRoute
    ) {
        super();
        this.businessTransactionNumber = +_route.snapshot.params['id']; // grab the business transaction from the route.
    }

    async ngOnInit() {
        if (!this.businessTransactionNumber) { // TODO: verify if this is the right approach
            this.businessTransactionNumber = this.nmvtisMessageModel.businessTransactionId;
        }
        this.vehicleNoTitleHistoryList = <VehicleNoTitleHistoryModel[]> this.nmvtisMessageModel.nmvtisResponse.vehicleNoTitleHistory;

        // TODO: see if we can use confirm Validation State, we still need to set the interaction state.

        this.businessTransactionTypeId = await this._transactionService.getTransactionTypeByBusinessTransactionId(this.businessTransactionNumber).pipe(first()).toPromise();

        this.transaction = await this._transactionService.getTransaction(this.businessTransactionNumber).pipe(first()).toPromise();
        this.setVehicleOwnershipReasonType();

        // TODO: see if we can use confirm Validation State, we still need to set the interaction state
        if (this.vehicleOwnershipReasonTypeId == new VehicleOwnershipReasonType().ManufCertofOriginMCO.id) {
            this.message = 'NMVTIS has found a vehicle. Ownership Reason is MCO. Confirm the vehicle status before proceeding.';
        } else {
            this.message = 'Vehicle Matched'; // this line should not execute at all.
        }

        this.dataLoaded = true;
    }

    private setVehicleOwnershipReasonType(): void {
        const businessTransacion = null;
        // in case of title types validate the MCO vehicleownership reason again since the value might have been changed by the CSR.
        const businessTransactionType: BusinessTransactionType = new BusinessTransactionType();
        const selectedTransaction = businessTransactionType.FromId(this.businessTransactionTypeId);
        switch (selectedTransaction) {
            case businessTransactionType.TitleandRegistration:
            case businessTransactionType.TitleOnly:
            case businessTransactionType.CancelTitle:
            case businessTransactionType.VoidTitle:
            case businessTransactionType.ManageLiensandBrands:
                let titleTransaction = <TitleOnlyModel> this.transaction;
                this.title = titleTransaction.title ? titleTransaction.title : titleTransaction.previousTitle;
                this.vehicleOwnershipReasonTypeId = this.title.vehicleOwnership.vehicleOwnershipReasonTypeID;
                break;

            case businessTransactionType.PrintTitle:
                let printTitleTransaction = <TitleOnlyModel> this.transaction;
                this.title = printTitleTransaction.previousTitle;

                this.vehicleOwnershipReasonTypeId = this.title.vehicleOwnership.vehicleOwnershipReasonTypeID;
                break;
        }
    }

    onSaveClick() {
        this.onSaved.emit(true);
    }
}
